<template>
  <Container>
    <v-flex justify-start>
      <v-card>
        <v-toolbar dark>
          <v-toolbar-title>Quiz To Go Manager</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn icon color="green" v-on:click="toggleSelectCategory">
            <v-icon>add</v-icon>
          </v-btn>
          <v-text-field
            solo
            placeholder="Search"
            append-icon="search"
            hide-details
          ></v-text-field>
        </v-toolbar>
        <v-card-text>
          <v-list>
            <v-list-tile
              v-for="wordwalk in questionStore.wordwalk"
              :key="wordwalk.category_id"
              v-on:click="() => onClickEdit(wordwalk._id, wordwalk.category_id)"
            >
              <v-list-tile-avatar>
                <v-icon>accessibility</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title
                  >{{ wordwalk.category }} ({{
                    wordwalk.questions.length
                  }})</v-list-tile-title
                >
                <v-list-tile-sub-title
                  >Updated at {{ wordwalk.updated_at }}</v-list-tile-sub-title
                >
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card-text>
      </v-card>
    </v-flex>
    <Category
      :v-if="isSelectCategory"
      :isOpen="isSelectCategory"
      :close="toggleSelectCategory"
      :onSelect="onClickSelectCategory"
      :value="categoryId"
      title="Select Category"
    >
    </Category>
  </Container>
</template>
<script>
import Container from '../../components/Container';
import Category from '../../components/Category';
import { mapActions, mapState } from 'vuex';
export default {
  name: 'WordwalkList',
  components: {
    Container,
    Category,
  },
  data: function () {
    return {
      isSelectCategory: false,
      categoryId: '',
    };
  },
  methods: {
    ...mapActions('wordwalks', [
      'fetchWordwalk',
      'selectWordwalk',
      'selectCategory',
      'updateWordWalkData',
    ]),
    onClickEdit(id, category_id) {
      this.selectWordwalk(category_id);
      this.selectCategory();
      this.updateWordWalkData({
        key: '_id',
        value: id,
      });
      this.$router.push({
        path: '/wordwalk/detail',
        query: {
          id: category_id,
        },
      });
    },
    toggleSelectCategory() {
      this.isSelectCategory = !this.isSelectCategory;
    },
    onClickSelectCategory(id) {
      this.isSelectCategory = false;
      this.selectCategory(id);
      this.selectWordwalk();
      this.$router.push({
        path: '/wordwalk/detail',
        query: {
          id,
        },
      });
    },
  },
  mounted() {
    this.fetchWordwalk({
      page: 1,
      limit: 0,
    });
  },
  computed: {
    ...mapState({
      questionStore: state => state.wordwalks,
    }),
  },
};
</script>
